import Header from "../../components/Header";
import Footer from "../../components/Footer";
import WhyUs from "components/whyus";
import { Bot, Users, ShieldCheck, CreditCard } from "lucide-react"; // آیکون جدید اضافه شد

export default function Home() {
  return (
    <div
      dir="rtl"
      className="min-h-screen bg-gradient-to-br from-slate-950 via-slate-900 to-emerald-950 text-slate-100"
    >
      <Header />

      {/* HERO */}
      <section className="max-w-7xl mx-auto px-6 py-24 grid md:grid-cols-2 gap-16 items-center">
        <div>
          <h1 className="text-4xl md:text-6xl font-bold leading-tight">
            ترید هوشمند با
            <br />
            <span className="text-emerald-400">
              هوش مصنوعی و منتورهای واقعی
            </span>
          </h1>

          <p className="mt-6 text-slate-300 max-w-xl leading-relaxed">
            دیپ‌ماین فایننس با ترکیب تحلیل‌های پیشرفته هوش مصنوعی و تجربه
            منتورهای حرفه‌ای، به تریدرها کمک می‌کند تصمیم‌های دقیق‌تر و
            سودآورتری بگیرند.
          </p>

          {/* دکمه‌های اکشن - دکمه پلن‌ها اضافه شد */}
          <div className="mt-10 flex flex-wrap gap-4">
            <a
              href="/chat"
              className="flex items-center gap-2 px-6 py-3 bg-emerald-500 text-black font-semibold rounded-xl hover:bg-emerald-400 transition"
            >
              <Bot size={18} />
              گفتگو با هوش مصنوعی
            </a>
            <a
              href="/mentors"
              className="flex items-center gap-2 px-6 py-3 border border-white/20 rounded-xl hover:border-emerald-400/40 transition"
            >
              <Users size={18} />
              مشاهده منتورها
            </a>
            {/* دکمه جدید: پلن‌ها */}
            <a
              href="/plans"
              className="flex items-center gap-2 px-6 py-3 border border-emerald-400/40 text-emerald-400 rounded-xl hover:bg-emerald-400/10 hover:border-emerald-300 transition font-medium"
            >
              <CreditCard size={18} />
              مشاهده پلن‌ها
            </a>
          </div>
        </div>

        {/* RIGHT CARD */}
        <div className="relative">
          <div className="absolute inset-0 bg-emerald-500/20 blur-3xl rounded-full" />
          <div className="relative bg-black/40 border border-white/10 p-8 rounded-2xl backdrop-blur-xl">
            <ul className="space-y-5 text-sm text-slate-200">
              <li>✔ تحلیل بازار و سیگنال‌های معاملاتی با AI</li>
              <li>✔ جلسات منتورینگ یک‌به‌یک با تریدرهای حرفه‌ای</li>
              <li>✔ مدیریت ریسک و سرمایه شخصی‌سازی‌شده</li>
              <li>✔ داشبورد بررسی عملکرد و پیشرفت</li>
              <li>✔ داشتن قیمت ۷۷۰ سهام بورس با قیمت لحظه ای</li>
              <li>✔ قیمت لحظه ای دلار، بیتکوین، اتریوم و ۵۰ ارز برتر بازار</li>
              <li>✔ داشتن قیمت سکه، طلا، نیم سکه، ربع و .....</li>
              <li>✔ داشتن قیمت ماشین های موجود در بازار ایران با قیمت لحظه ای</li>
              <li>✔ داشتن قیمت گوشی های موجود در بازار ایران</li>
            </ul>
          </div>
        </div>
      </section>

      {/* FEATURES */}
      <section className="border-t border-white/10 bg-black/30">
        <div className="max-w-7xl mx-auto px-6 py-20 grid md:grid-cols-3 gap-10">
          <Feature
            icon={<Bot size={20} />}
            title="موتور ترید هوشمند"
            desc="تحلیل داده‌های بازار با مدل‌های پیشرفته هوش مصنوعی"
          />
          <Feature
            icon={<Users size={20} />}
            title="منتورهای حرفه‌ای"
            desc="دسترسی مستقیم به تریدرهای سودده و باتجربه"
          />
          <Feature
            icon={<ShieldCheck size={20} />}
            title="پلتفرم امن مالی"
            desc="امنیت سطح سازمانی و حفاظت کامل از داده‌ها"
          />
        </div>
      </section>

      <WhyUs />

      <Footer />
    </div>
  );
}

function Feature({ icon, title, desc }) {
  return (
    <div className="p-8 rounded-2xl bg-white/5 border border-white/10 hover:border-emerald-400/30 transition">
      <div className="text-emerald-400 mb-4">{icon}</div>
      <h3 className="text-lg font-semibold">{title}</h3>
      <p className="text-sm text-slate-300 mt-2 leading-relaxed">
        {desc}
      </p>
    </div>
  );
}